import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-tables',
  templateUrl: './meta-tables.component.html',
  styleUrls: ['./meta-tables.component.css']
})
export class MetaTablesComponent implements OnInit {
    public itemsListMetaTables: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadMetaTables(): Promise<void> {
        this.itemsListMetaTables = await this.datatask.Post(2371);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'metatable':
                this.stateService?.go('metatable', { metatable_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMetaTables();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTables', {
//        templateUrl: 'views/components/views/metaTables/metaTables.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'metaTablesService', function (stateService, metaTablesService) {
//            const vm = this;

//            vm.model = {
//                itemsListMetaTables: []
//            };

//            async function loadMetaTables() {
//                vm.model.itemsListMetaTables = await metaTablesService.listMetaTables();
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metatable':
//                        go({ metatable_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadMetaTables();
//            }
//        }]
//    });
//})();
